<template>
  <div id="customField">

      <!-- 设置表头 -->
      <el-dialog title="设置表格" :visible.sync="headerShow" width="960px" id="setHeader">
        <div class="headerBorder"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading">
          <el-row style="heigth: 450px;">
            <el-col :span="18" style="border-right: 1px solid #d9d9d9;">
              <div class="fontback">
                可用字段
              </div>
              <div class="fontback2">
                产品字段
                <span style="color: rgb(219, 71, 87);font-size: 12px;">
                “品名”字段支持修改名称；标红字段为价格表信息录入时产品信息唯一性的标识字段。
                </span>
              </div>
              <div class="overflowStyle">
              <div style="margin-left: 20px;margin-top: 10px;">
                <span v-for="(item,index) in orderProduct" :key='index' style="width: 218px;display: inline-block;">
                  <el-tooltip class="item" effect="dark" :content="item.fieldvalue" placement="top">
                    <span @mouseover="iconShowTrue(index,item.fieldRequired)" @mouseout="iconShowFalse(index,item.fieldRequired)">
                      <el-checkbox :label="item.fieldname"
                        style="margin-bottom: 10px;width: 116px;"
                        :disabled="item.fieldRequired == 1 || item.fieldUnique == '1'"
                        v-model="shishi[index]"
                        v-show="checkboxShow[index]"
                        @change="checkboxEmpty(item.fieldname,index,item.id,item.fieldRequired,1)">
                      </el-checkbox>
                      <span style="position: relative;top: 0;z-index: 9;left: -103px;color: red;" v-if="item.fieldUnique == 1">
                        ●
                      </span>
                      <el-input onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" v-model="fieldname[index]" placeholder="请输入内容" maxlength='10' size="small" style="width:158px;" v-show="inputShow[index]"></el-input>
                      <span v-show="iconShow[index]" class="iconShowStyle">
                        <i class="el-icon-edit-outline" style="margin-right: 5px;margin-left: 5px;" @click="InputShow(index,item.fieldname)"></i>
                        <i class="el-icon-refresh" slot="reference" @click="convertNote(index)" v-if="item.fieldRequired != 1 && item.fieldUnique != 1"></i>
                        <!-- 产品字段转换 -->
                        <el-popover placement="top" width="200" v-model="conversion[index]">
                          <span><i class="el-icon-warning" style="color: #ffaa16;margin-top: 10px;"></i></span>
                          <span class="zhStyle">你确定要将该字段转到“备注字段”吗？</span>
                          <div style="text-align: right; margin-top: 15px;">
                            <el-button type="primary" size="small" @click="confirmConversion(index,1,item.id)" style="margin-left: 5px;">确 定</el-button>
                            <el-button size="small" @click="confirmConversion(index,2)" type="TheCustom">取 消</el-button>
                          </div>
                        </el-popover>
                        <i class="el-icon-discount" slot="reference" style="margin-right: 5px;margin-left: 5px;" @click="redFun(index,1)" v-if="redArr.length != 1 || item.fieldUnique == 0"></i>
                        <!-- 产品字段唯一性 -->
                        <el-popover placement="top" width="200" v-model="redShow[index]">
                          <span><i class="el-icon-warning" style="color: #ffaa16;margin-top: 10px;"></i></span>
                          <span class="zhStyle">
                            你确定要将该字段<span v-if="item.fieldUnique == 1">取消</span><span v-else>设置</span>为“唯一性”识别字段吗？
                          </span>
                          <div style="text-align: right; margin-top: 15px;">
                            <el-button type="primary" size="small" @click="updateUnique(item.fieldUnique,item.id,index)" style="margin-left: 5px;">确 定</el-button>
                            <el-button size="small" @click="redFun(index,2)" type="TheCustom">取 消</el-button>
                          </div>
                        </el-popover>


                        <!-- 产品字段删除 -->
                        <i class="el-icon-delete" slot="reference" @click="referenceDelete(index)" v-if="item.fieldRequired != 1 && item.fieldUnique != 1"></i>
                        <el-popover placement="top" width="200" v-model="popovervisible[index]">
                          <span><i class="el-icon-warning" style="color: #ffaa16;margin-top: 10px;"></i></span>
                          <span class="zhStyle">你确定要删除该字段吗？</span>
                          </br>
                          <span style="color: #db4757;margin-left: 23px;">删除后录入的信息会被删除</span>
                          <div style="text-align: right; margin-top: 15px;">
                            <el-button type="primary" size="small" @click="deleteProductField(index,1,item.id)" style="margin-left: 5px;">确 定</el-button>
                            <el-button size="small" @click="deleteProductField(index,2)" type="TheCustom">取 消</el-button>
                          </div>
                        </el-popover>
                      </span>

                      <span v-show="succShow[index]" style="color: #108cee;cursor: pointer;">
     									 <i class="el-icon-check" style="margin-right: 5px;margin-left: 5px;" @click="productField(index,1,item.id,item.fieldClassify)"></i>
     									 <i class="el-icon-close" @click="productField(index,2)"></i>
     								  </span>
                    </span>
                  </el-tooltip>
                </span>
                <span style="color: #108cee;cursor: pointer;">
                 <i class="el-icon-circle-plus-outline" style="margin-right: 16px;width: 14px;height: 14px;" v-show="addFieldnameHidden" @click="addProductField()"></i>
                 <span v-show="addFieldnameHidden" @click="addProductField()">新增</span>
                 <el-input autofocus onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" v-model="addFieldname" maxlength='10' placeholder="请输入内容" size="small" style="width:158px;" v-show="addFieldnameShow"></el-input>
                 <i class="el-icon-check" style="margin-right: 5px;margin-left: 5px;" @click="addFieldnamesucc(1)" v-show="addFieldnameShow"></i>
                 <i class="el-icon-close" @click="addFieldnamesucc(2)" v-show="addFieldnameShow"></i>
                </span>
              </div>


              <div class="fontback2">
                价格字段
                <span style="color: rgb(219, 71, 87);font-size: 12px;padding-left: 8px;">
                  价格字段信息请在此处新增
                </span>
              </div>
              <div style="margin-left: 20px;margin-top: 10px;">
                <span v-for="(item,index) in orderPrice" :key='index' style="width: 218px;display: inline-block;">
                  <el-tooltip class="item" effect="dark" :content="item.fieldvalue" placement="top">
                    <span @mouseover="iconShowTrue2(index,item.fieldRequired)" @mouseout="iconShowFalse2(index,item.fieldRequired)">
                      <el-checkbox :label="item.fieldname" style="margin-bottom: 10px;width: 143px;" :disabled="item.fieldRequired == 1"
                       v-model="shishi2[index]" v-show="checkboxShow2[index]" @change="checkboxEmpty(item.fieldname,index,item.id,item.fieldRequired,2)"></el-checkbox>
                       <el-input onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" v-model="fieldname2[index]" maxlength='10' placeholder="请输入内容" size="small" style="width:158px;" v-show="inputShow2[index]"></el-input>
                      <span v-show="iconShow2[index]" class="iconShowStyle">
     									 <i class="el-icon-edit-outline" style="margin-right: 5px;margin-left: 5px;" @click="InputShow2(index,item.fieldname)"></i>
                       <li class="el-icon-delete" slot="reference" @click="referenceDelete2(index)"></li>
                       <el-popover
                          placement="top"
                          width="200"
                          v-model="popovervisible2[index]">
                          <span><i class="el-icon-warning" style="color: #ffaa16;margin-top: 10px;"></i></span>
                          <span class="zhStyle">你确定要删除该字段吗？</span>
                          </br>
                          <span style="color: #db4757;margin-left: 23px;">删除后录入的信息会被删除</span>
                          <div style="text-align: right; margin-top: 15px;">
                            <el-button type="primary" size="small" @click="deleteProductField2(index,1,item.id)" style="margin-left: 5px;">确 定</el-button>

                            <el-button size="small" @click="deleteProductField2(index,2)" type="TheCustom">取 消</el-button>
                          </div>
                        </el-popover>
     								  </span>

                      <span v-show="succShow2[index]" style="color: #108cee;cursor: pointer;">
     									 <i class="el-icon-check" style="margin-right: 5px;margin-left: 5px;" @click="productField2(index,1,item.id,item.fieldClassify)"></i>
     									 <i class="el-icon-close" @click="productField2(index,2)"></i>
     								  </span>
                    </span>
                  </el-tooltip>
                </span>
                <span style="color: #108cee;cursor: pointer;">
                 <i class="el-icon-circle-plus-outline" style="margin-right: 16px;width: 14px;height: 14px;" v-show="addFieldnameHidden2" @click="addProductField2()"></i>
                 <span v-show="addFieldnameHidden2" @click="addProductField2()">新增</span>
                 <el-input autofocus onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" v-model="addFieldname2" maxlength='10' placeholder="请输入内容" size="small" style="width:158px;" v-show="addFieldnameShow2"></el-input>
                 <i class="el-icon-check" style="margin-right: 5px;margin-left: 5px;" @click="addFieldnamesucc2(1)" v-show="addFieldnameShow2"></i>
                 <i class="el-icon-close" @click="addFieldnamesucc2(2)" v-show="addFieldnameShow2"></i>
                </span>
              </div>


              <div class="fontback2">
                备注字段
              </div>
              <div style="margin-left: 20px;margin-top: 10px;">
                <span v-for="(item,index) in orderMemo" :key='index' style="width: 218px;display: inline-block;">
                  <el-tooltip class="item" effect="dark" :content="item.fieldvalue" placement="top">
                    <span @mouseover="iconShowTrue3(index,item.fieldRequired)" @mouseout="iconShowFalse3(index,item.fieldRequired)">
                      <el-checkbox :label="item.fieldname" style="margin-bottom: 10px;width: 143px;"
                       :disabled="item.fieldRequired == 1" v-model="shishi3[index]" v-show="checkboxShow3[index]" @change="checkboxEmpty(item.fieldname,index,item.id,item.fieldRequired,3)"></el-checkbox>
                       <el-input onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" v-model="fieldname3[index]" maxlength='10' placeholder="请输入内容" size="small" style="width:158px;" v-show="inputShow3[index]"></el-input>
                      <span v-show="iconShow3[index]" class="iconShowStyle">
     									 <i class="el-icon-edit-outline" style="margin-right: 5px;margin-left: 5px;" @click="InputShow3(index,item.fieldname)"></i>
                       <i class="el-icon-refresh" slot="reference" style="margin-right: 5px;" @click="convertNote2(index)"></i>
                       <!-- 产品字段转换 -->
                       <el-popover placement="top" width="200" v-model="conversion2[index]">
                       <span><i class="el-icon-warning" style="color: #ffaa16;margin-top: 10px;"></i></span>
                       <span class="zhStyle">你确定要将该字段转到“产品字段”吗？</span>
                       <div style="text-align: right; margin-top: 15px;">
                         <el-button type="primary" size="small" @click="confirmConversion2(index,1,item.id)" style="margin-left: 5px;">确 定</el-button>
                         <el-button size="small" @click="confirmConversion2(index,2)" type="TheCustom">取 消</el-button>
                       </div>
                       </el-popover>
                       <li class="el-icon-delete" slot="reference" @click="referenceDelete3(index)"></li>
                       <el-popover
                        placement="top"
                        width="200"
                        v-model="popovervisible3[index]">
                        <span><i class="el-icon-warning" style="color: #ffaa16;margin-top: 10px;"></i></span>
                        <span class="zhStyle">你确定要删除该字段吗？</span>
                        </br>
                        <span style="color: #db4757;margin-left: 23px;">删除后录入的信息会被删除</span>
                        <div style="text-align: right; margin-top: 15px;">
                          <el-button type="primary" size="small" @click="deleteProductField3(index,1,item.id)" style="margin-right: 10px;">确 定</el-button>

                          <el-button size="small" @click="deleteProductField3(index,2)" type="TheCustom">取 消</el-button>
                        </div>
                      </el-popover>
     								  </span>

                      <span v-show="succShow3[index]" style="color: #108cee;cursor: pointer;">
     									 <i class="el-icon-check" style="margin-right: 5px;margin-left: 5px;" @click="productField3(index,1,item.id,item.fieldClassify)"></i>
     									 <i class="el-icon-close" @click="productField3(index,2)"></i>
     								  </span>
                    </span>
                  </el-tooltip>
                </span>
                <span style="color: #108cee;cursor: pointer;">
                 <i class="el-icon-circle-plus-outline" style="margin-right: 16px;width: 14px;height: 14px;" v-show="addFieldnameHidden3" @click="addProductField3()"></i>
                 <span v-show="addFieldnameHidden3" @click="addProductField3()">新增</span>
                 <el-input autofocus onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" v-model="addFieldname3" maxlength='10' placeholder="请输入内容" size="small" style="width:158px;" v-show="addFieldnameShow3"></el-input>
                 <i class="el-icon-check" style="margin-right: 5px;margin-left: 5px;" @click="addFieldnamesucc3(1)" v-show="addFieldnameShow3"></i>
                 <i class="el-icon-close" @click="addFieldnamesucc3(2)" v-show="addFieldnameShow3"></i>
                </span>
              </div>
            </div>

            </el-col>
            <el-col :span="6" >
              <div class="fontback">
                已选字段
              </div>
              <div class="overflowStyle" style="margin-top: 12px;">
                <el-tree
                  :data="treeTotal"
                  node-key="id"
                  default-expand-all
                  draggable
                  :allow-drop="allowDrop"
                  :allow-drag="allowDrag"
                  >
                  <span class="custom-tree-node" slot-scope="{ node, data }" style="width: 200px;">
                    <el-row>
                      <el-col :span="20"><img src="../../assets/img/sort.jpg" style="margin-right: 10px;width: 7px;height: 12px;" />{{ node.data.label }}</el-col>
                      <el-col :span="4" style="text-align: right;">
                        <i class="el-icon-circle-close" v-show="node.data.fieldRequired != 1" @click="empty(node.data.label,node.data.index)"></i>
                      </el-col>
                    </el-row>
                  </span>
                </el-tree>
              </div>
            </el-col>
          </el-row>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="saveSort" size="small" style="margin-right: 10px;">确 定</el-button>
          <el-button @click="headerShow = false" size="small" type="TheCustom">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 设置表头 -->
    </div>
  </div>
</template>

<script>
  import axios from "axios";

  export default {
    name: 'customField',
    // props:[""]
    data() {
      return {
        loading: false,
        classifyidField: '',
        addFieldname: '',
        addFieldname2: '',
        addFieldname3: '',
        shishi: [],
        addFieldnameShow: false,
        addFieldnameHidden: true,
        popovervisible: [],
        conversion: [],
        conversion2: [],
        fieldname: [],
        fieldname2: [],
        fieldname3: [],
        tableData: [],
        allorder: [],
        fieldvalue: [],
        orderProduct: [],
        orderProduct2: [],
        orderPrice: [],
        keyArray: [],
        iconShow2: [],
        inputShow2: [],
        checkboxShow2: [],
        succShow2: [],
        isShow2: [],
        popovervisible2: [],
        shishi2: [],
        keyArray2: [],
        addFieldnameHidden2: true,
        addFieldnameShow2: false,
        names: [],
        iconShow3: [],
        inputShow3: [],
        checkboxShow3: [],
        succShow3: [],
        isShow3: [],
        popovervisible3: [],
        shishi3: [],
        keyArray3: [],
        addFieldnameHidden3: true,
        addFieldnameShow3: false,
        orderMemo: [],
        submitArray: {},
        headerShow: false,
        sigin: false,
        sigin2: false,
        sigin3: false,
        inputShow: [],
        iconShow: [],
        checkboxShow: [],
        succShow: [],
        isShow: [],
        ids: [],
        treeTotal: [],
        redArr: [],
        redShow: [],
        redUnique: '',
      }
    },
    methods: {
      // 产品字段唯一性弹窗
      redFun(idnex,e) {
        if (e == 1) {
          this.$set(this.redShow,idnex,true);
        } else {
          this.$set(this.redShow,idnex,false);
        }

      },
      // 产品字段唯一性更新接口
      updateUnique(redUnique,redId,idnex) {
        this.$set(this.redShow,idnex,false);
        if (redUnique == 1) {
          this.redUnique = '0'
        } else {
          this.redUnique = '1'
        }
        let params={
          id: redId,
          unique: this.redUnique,
        }
        fetch({
          url: "hcm/hcmCustomModel/updateUnique",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.getOrder();
            this.$emit('customShow')
          } else {
            this.$message.error(res.message);
          }
        })
      },
      saveSort() {
        this.ids = [];
        this.names = [];
        for (var i = 0; i < this.treeTotal.length; i++) {
          this.ids.push(this.treeTotal[i].id)
          this.names.push(this.treeTotal[i].label)
        }
        let params={
          ids: this.ids.toString(),
          names: this.names.toString(),
          productClassifyId: this.$route.query.e,
          module: 'PRODUCT',
        }
        fetch({
          url: "hcm/hcmCustomModel/saveSort",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.headerShow = false
            this.ids = [];
            this.getOrder();
            this.$emit('customShow')
          } else {
            this.$message.error(res.message);
          }
        })
      },
      checkboxEmpty(e,f,h,g,index) {
        if (index == 1 && this.shishi[f] == false) {
          for (var i = 0; i < this.treeTotal.length; i++) {
            if (this.treeTotal[i].label == e){
              this.treeTotal.splice(i, 1);
            }
          }
        } else if (index == 2 && this.shishi2[f] == false) {
          for (var i = 0; i < this.treeTotal.length; i++) {
            if (this.treeTotal[i].label == e){
              this.treeTotal.splice(i, 1);
            }
          }
        } else if (index == 3 && this.shishi3[f] == false) {
          for (var i = 0; i < this.treeTotal.length; i++) {
            if (this.treeTotal[i].label == e){
              this.treeTotal.splice(i, 1);
            }
          }
        } else {
          this.treeTotal.push(
            {
              id: h,
              label: e,
              fieldRequired: g,
              index: f,
            }
          );
        }
      },
      empty(e,f) {
        for (var i = 0; i < this.treeTotal.length; i++) {
          if (this.treeTotal[i].label == e){
            if (this.treeTotal[i].type === '1'){
              this.shishi[f] = false
            } else if (this.treeTotal[i].type === '2') {
              this.shishi2[f] = false
            } else if (this.treeTotal[i].type === '3') {
              this.shishi3[f] = false
            }
            this.treeTotal.splice(i, 1);
          }
        }
      },
      referenceDelete(e) {
        this.$set(this.popovervisible,e,true);
        this.sigin = true
      },
      convertNote(e) {
        this.$set(this.conversion,e,true);
      },
      convertNote2(e) {
        this.$set(this.conversion2,e,true);
      },
      referenceDelete2(e) {
        this.$set(this.popovervisible2,e,true);
        this.sigin2 = true
      },
      referenceDelete3(e) {
        this.$set(this.popovervisible3,e,true);
        this.sigin3 = true
      },
      // 产品字段删除  确认  取消
      deleteProductField(e,f,h) {
        if (f == 1) {
          this.$set(this.popovervisible,e,false);
          this.sigin = false
          let params={
            id: h,
            module: 'PRODUCT',
          }
          fetch({
            url: "hcm/hcmCustomModel/delete",
            method: "post",
            params: params,
            noFormat: true,
            responseType: "text"
          }).then(result => {
            let res = JSON.parse(result);
            let {data}=res
            if(res.status == '10000'){
              this.getOrder();
              this.$emit('customShow')
            }
          })
        } else {
          this.$set(this.popovervisible,e,false);
          this.sigin = false
        }
      },
      // 产品字段转换  确认  取消
      confirmConversion(e,f,h) {
        if (f == 1) {
          this.$set(this.conversion,e,false);
          let params={
            id: h,
            field_classify: 'MEMO',
          }
          fetch({
            url: "hcm/hcmCustomModel/change",
            method: "post",
            params: params,
            noFormat: true,
            responseType: "text"
          }).then(result => {
            let res = JSON.parse(result);
            let {data}=res
            if(res.status == '10000'){
              this.getOrder();
              this.$emit('customShow')
            }
          })
        } else {
          this.$set(this.conversion,e,false);
        }
      },
      // 价格字段删除  确认  取消
      deleteProductField2(e,f,h) {
        if (f == 1) {
          this.$set(this.popovervisible2,e,false);
          this.sigin2 = false
          let params={
            id: h,
            module: 'PRODUCT',
          }
          fetch({
            url: "hcm/hcmCustomModel/delete",
            method: "post",
            params: params,
            noFormat: true,
            responseType: "text"
          }).then(result => {
            let res = JSON.parse(result);
            let {data}=res
            if(res.status == '10000'){
              this.getOrder();
              this.$emit('customShow')
              this.openPhoneShow2 = false
            } else if (res.status == '10400') {
            }
          })
        } else {
          this.$set(this.popovervisible2,e,false);
          this.sigin2 = false
        }

      },
      // 备注字段删除  确认  取消
      deleteProductField3(e,f,h) {
        if (f == 1) {
          this.$set(this.popovervisible3,e,false);
          this.sigin3 = false
          let params={
            id: h,
            module: 'PRODUCT',
          }
          fetch({
            url: "hcm/hcmCustomModel/delete",
            method: "post",
            params: params,
            noFormat: true,
            responseType: "text"
          }).then(result => {
            let res = JSON.parse(result);
            let {data}=res
            if(res.status == '10000'){
              this.getOrder();
              this.$emit('customShow')
              this.openPhoneShow3 = false
            } else if (res.status == '10400') {
            }
          })
        } else {
          this.$set(this.popovervisible3,e,false);
          this.sigin3 = false
        }
      },
      // 备注字段转换  确认  取消
      confirmConversion2(e,f,h) {
        if (f == 1) {
          this.$set(this.conversion2,e,false);
          let params={
            id: h,
            field_classify: 'PRODUCT',
          }
          fetch({
            url: "hcm/hcmCustomModel/change",
            method: "post",
            params: params,
            noFormat: true,
            responseType: "text"
          }).then(result => {
            let res = JSON.parse(result);
            let {data}=res
            if(res.status == '10000'){
              this.getOrder();
              this.$emit('customShow')
            }
          })
        } else {
          this.$set(this.conversion2,e,false);
        }
      },
      InputShow(e,f) {
        this.fieldname[e]= f
        this.$set(this.inputShow,e,true);
        this.$set(this.checkboxShow,e,false);
        this.$set(this.isShow,e,true);
        this.$set(this.succShow,e,true);
      },
      InputShow2(e,f) {
        this.fieldname2[e]= f
        this.$set(this.inputShow2,e,true);
        this.$set(this.checkboxShow2,e,false);
        this.$set(this.isShow2,e,true);
        this.$set(this.succShow2,e,true);
      },
      InputShow3(e,f) {
        this.fieldname3[e]= f
        this.$set(this.inputShow3,e,true);
        this.$set(this.checkboxShow3,e,false);
        this.$set(this.isShow3,e,true);
        this.$set(this.succShow3,e,true);
      },
      addProductField() {
        this.addFieldnameShow = true
        this.addFieldnameHidden= false
      },
      addProductField2() {
        this.addFieldnameShow2 = true
        this.addFieldnameHidden2= false
      },
      addProductField3() {
        this.addFieldnameShow3 = true
        this.addFieldnameHidden3= false
      },
      addFieldnamesucc(e) {
        if (e==1) {
          if (this.addFieldname == '') {
            this.$message.error('请填写内容');
            return;
          }
          if (this.addFieldname.indexOf(".") != -1) {
            this.$message.error('填写内容不能有小数点');
            return;
          }
          this.addFieldnameHidden = true
          this.addFieldnameShow = false
          let params={
            fieldname: this.addFieldname,
            productClassifyId: this.$route.query.e,
            fieldClassify: 'PRODUCT',
            module: 'PRODUCT',
          }
          fetch({
            url: "hcm/hcmCustomModel/save",
            method: "post",
            params: params,
            noFormat: true,
            responseType: "text"
          }).then(result => {
            let res = JSON.parse(result);
            let {data}=res
            if(res.status == '10000'){
              this.getOrder();
              this.$emit('customShow',1)
              this.addFieldname = ''
            } else {
              this.$message.error(res.message);
              this.addFieldname = ''
            }
          })
        } else {
          this.addFieldnameHidden = true
          this.addFieldnameShow = false
          this.addFieldname = ''
        }
      },
      addFieldnamesucc2(e) {
        if (e==1) {
          if (this.addFieldname2 == '') {
            this.$message.error('请填写内容');
            return;
          }
          if (this.addFieldname2.indexOf(".") != -1) {
            this.$message.error('填写内容不能有小数点');
            return;
          }
          this.addFieldnameHidden2 = true
          this.addFieldnameShow2 = false
          let params={
            fieldname: this.addFieldname2,
            productClassifyId: this.$route.query.e,
            fieldClassify: 'PRICE',
            module: 'PRODUCT',
          }
          fetch({
            url: "hcm/hcmCustomModel/save",
            method: "post",
            params: params,
            noFormat: true,
            responseType: "text"
          }).then(result => {
            let res = JSON.parse(result);
            let {data}=res
            if(res.status == '10000'){
              this.getOrder();
              this.$emit('customShow',1)
              this.addFieldname2 = ''
            } else {
              this.$message.error(res.message);
              this.addFieldname2 = ''
            }
          })
        } else {
          this.addFieldnameHidden2 = true
          this.addFieldnameShow2 = false
          this.addFieldname2 = ''
        }
      },
      addFieldnamesucc3(e) {
        if (e==1) {
          if (this.addFieldname3 == '') {
            this.$message.error('请填写内容');
            return;
          }
          if (this.addFieldname3.indexOf(".") != -1) {
            this.$message.error('填写内容不能有小数点');
            return;
          }
          this.addFieldnameHidden3 = true
          this.addFieldnameShow3 = false
          let params={
            fieldname: this.addFieldname3,
            productClassifyId: this.$route.query.e,
            fieldClassify: 'MEMO',
            module: 'PRODUCT',
          }
          fetch({
            url: "hcm/hcmCustomModel/save",
            method: "post",
            params: params,
            noFormat: true,
            responseType: "text"
          }).then(result => {
            let res = JSON.parse(result);
            let {data}=res
            if(res.status == '10000'){
              this.getOrder();
              this.$emit('customShow',1)
              this.addFieldname3 = ''
            } else {
              this.$message.error(res.message);
              this.addFieldname3 = ''
            }
          })
        } else {
          this.addFieldnameHidden3 = true
          this.addFieldnameShow3 = false
          this.addFieldname3 = ''
        }
      },
      allowDrop(draggingNode, dropNode, type) {
        if (draggingNode.data.level === dropNode.data.level) {
          if (draggingNode.data.aboveId === dropNode.data.aboveId) {
            return type === 'prev' || type === 'next'
          }
        } else {
          // 不同级进行处理
          return false
        }
      },
      allowDrag(draggingNode) {
        return draggingNode.data.label.indexOf('三级 3-2-2') === -1;
      },

      iconShowTrue(e,f) {
        if (this.isShow[e] != true) {
          this.$set(this.iconShow,e,true);
        }
      },
      iconShowFalse(e) {
        if (this.sigin == false) {
          this.$set(this.iconShow,e,false);
        }
      },
      iconShowTrue2(e,f) {
        if (f != 1 && this.isShow2[e] != true) {
          this.$set(this.iconShow2,e,true);
        }
      },
      iconShowFalse3(e) {
        if (this.sigin3 == false) {
          this.$set(this.iconShow3,e,false);
        }
      },
      iconShowTrue3(e,f) {
        if (f != 1 && this.isShow3[e] != true) {
          this.$set(this.iconShow3,e,true);
        }
      },
      iconShowFalse2(e) {
        if (this.sigin2 == false) {
          this.$set(this.iconShow2,e,false);
        }
      },
      productField(e,f,g,h) {
        if (f == 1) {
          this.$set(this.isShow,e,false);
          this.$set(this.inputShow,e,false);
          this.$set(this.succShow,e,false);
          this.$set(this.checkboxShow,e,true);
          let params={
            id: g,
            productClassifyId: this.$route.query.e,
            fieldname: this.fieldname[e],
            module: h,
            fieldClassify: h,
          }
          fetch({
            url: "hcm/hcmCustomModel/save",
            method: "post",
            params: params,
            noFormat: true,
            responseType: "text"
          }).then(result => {
            let res = JSON.parse(result);
            let {data}=res
            if(res.status == '10000'){
              this.getOrder();
              this.$emit('customShow',1)
              this.fieldname[e] = '';
            } else {
              this.$message.error(res.message);
              this.fieldname[e] = '';
            }
          })
        } else {
          this.$set(this.isShow,e,false);
          this.$set(this.inputShow,e,false);
          this.$set(this.succShow,e,false);
          this.$set(this.checkboxShow,e,true);
        }
      },
      productField2(e,f,g,h) {
        if (f == 1) {
          this.$set(this.isShow2,e,false);
          this.$set(this.inputShow2,e,false);
          this.$set(this.succShow2,e,false);
          this.$set(this.checkboxShow2,e,true);
          let params={
            id: g,
            productClassifyId: this.$route.query.e,
            fieldname: this.fieldname2[e],
            module: 'PRODUCT',
            fieldClassify: h,
          }
          fetch({
            url: "hcm/hcmCustomModel/save",
            method: "post",
            params: params,
            noFormat: true,
            responseType: "text"
          }).then(result => {
            let res = JSON.parse(result);
            let {data}=res
            if(res.status == '10000'){
              this.getOrder();
              this.$emit('customShow',1)
              this.fieldname2[e] = '';
            } else {
              this.$message.error(res.message);
              this.fieldname2[e] = '';
            }
          })
        } else {
          this.$set(this.isShow2,e,false);
          this.$set(this.inputShow2,e,false);
          this.$set(this.succShow2,e,false);
          this.$set(this.checkboxShow2,e,true);
        }
      },
      productField3(e,f,g,h) {
        if (f == 1) {
          this.$set(this.isShow3,e,false);
          this.$set(this.inputShow3,e,false);
          this.$set(this.succShow3,e,false);
          this.$set(this.checkboxShow3,e,true);
          let params={
            id: g,
            productClassifyId: this.$route.query.e,
            fieldname: this.fieldname3[e],
            module: 'PRODUCT',
            fieldClassify: h,
          }
          fetch({
            url: "hcm/hcmCustomModel/save",
            method: "post",
            params: params,
            noFormat: true,
            responseType: "text"
          }).then(result => {
            let res = JSON.parse(result);
            let {data}=res
            if(res.status == '10000'){
              this.getOrder();
              this.$emit('customShow',1)
              this.fieldname3[e] = '';
            } else {
              this.$message.error(res.message);
              this.fieldname3[e] = '';
            }
          })
        } else {
          this.$set(this.isShow3,e,false);
          this.$set(this.inputShow3,e,false);
          this.$set(this.succShow3,e,false);
          this.$set(this.checkboxShow3,e,true);
        }
      },
      childShow(e) {
        this.classifyidField = e
        this.headerShow = true
        this.getOrder(e)
      },
      getOrder(e) {
        this.loading = true
        let params={
          productClassifyid: this.classifyidField
        }
        fetch({
          url: "hcm/hcmCustomModel/getByProduct",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.loading = false
            this.orderMemo = data.memo.data;
            this.orderPrice = data.price.data;
            this.orderProduct = data.product.data;
            this.orderProduct2 = [];
            this.redArr = [];
            if (e != 1) {
              for (var i = 0; i < data.product.data.length; i++) {
                if (data.product.data[i].isChecked == 1) {
                  this.orderProduct2.push({
                    fieldvalue: data.product.data[i].fieldvalue,
                    fieldname: data.product.data[i].fieldname,
                  });
                }
                if (data.product.data[i].fieldUnique == 1) {
                  this.redArr.push(1)
                }
                this.redShow.push(false)
              }
            }
            var newarry = [];
            var newarry2 = [];
            var arrv = [];
            newarry = this.orderPrice.concat(this.orderProduct);
            newarry2 = this.orderMemo.concat(newarry);
            this.compare();
            newarry2.sort(this.compare('sort'));
            if (e != 1) {
              this.allorder = newarry2;
            }
            this.tableData.forEach((v,i)=>{
              Object.keys(v).forEach(v=>{
                  arrv.push(v)
              })
            })
            this.treeTotal = [];
            this.shishi = [];
            this.shishi2 = [];
            this.shishi3 = [];
            for (var i = 0; i < this.orderProduct.length; i++) {
              this.iconShow.push(false)
              this.inputShow.push(false)
              this.checkboxShow.push(true)
              this.succShow.push(false)
              this.isShow.push(false)
              this.popovervisible.push(false)
              this.conversion.push(false)
              if (this.orderProduct[i].isChecked == 1) {
                this.shishi.push(true)
              } else {
                this.shishi.push(false)
              }
              this.keyArray.push(this.orderProduct[i].fieldvalue)
              if (this.orderProduct[i].isChecked == 1) {
                this.treeTotal.push(
                  {
                    id: this.orderProduct[i].id,
                    label: this.orderProduct[i].fieldname,
                    fieldRequired: this.orderProduct[i].fieldRequired,
                    index: i,
                    sort: this.orderProduct[i].sort,
                    type: '1'
                  }
                );
              }

            }
            for (var i = 0; i < this.orderPrice.length; i++) {
              this.iconShow2.push(false)
              this.inputShow2.push(false)
              this.checkboxShow2.push(true)
              this.succShow2.push(false)
              this.isShow2.push(false)
              this.popovervisible2.push(false)
              if (this.orderPrice[i].isChecked == 1) {
                this.shishi2.push(true)
              } else {
                this.shishi2.push(false)
              }
              this.keyArray2.push(this.orderPrice[i].fieldvalue)
              if (this.orderPrice[i].isChecked == 1) {
                this.treeTotal.push(
                  {
                    id: this.orderPrice[i].id,
                    label: this.orderPrice[i].fieldname,
                    fieldRequired: this.orderPrice[i].fieldRequired,
                    index: i,
                    sort: this.orderPrice[i].sort,
                    type: '2'
                  }
                );
              }
            }
            for (var i = 0; i < this.orderMemo.length; i++) {
              this.iconShow3.push(false)
              this.inputShow3.push(false)
              this.checkboxShow3.push(true)
              this.succShow3.push(false)
              this.isShow3.push(false)
              this.popovervisible3.push(false)
              this.conversion2.push(false)
              if (this.orderMemo[i].isChecked == 1) {
                this.shishi3.push(true)
              } else {
                this.shishi3.push(false)
              }
              this.keyArray3.push(this.orderMemo[i].fieldvalue)
              if (this.orderMemo[i].isChecked == 1) {
                this.treeTotal.push(
                  {
                    id: this.orderMemo[i].id,
                    label: this.orderMemo[i].fieldname,
                    fieldRequired: this.orderMemo[i].fieldRequired,
                    index: i,
                    sort: this.orderMemo[i].sort,
                    type: '3'
                  }
                );
              }
            }
            this.compare();
            this.treeTotal.sort(this.compare('sort'));
          }
        })
      },
      //数组排序
      compare(property) {
        return function (a, b) {
          var value1 = a[property];
          var value2 = b[property];
          return value1 - value2;
        }
      },

    },
  }
</script>
<style scoped lang="scss">
  .overflowStyle {
    height: 369px;
    overflow-x: hidden;
    overflow-y: scroll;
  }
  .iconShowStyle {
    color: #108cee;
    cursor: pointer;
    background-color: white;
    z-index: 9999;
    position: absolute;
  }
  .zhStyle {
    margin-left: 9px;
    color: #585858;
    font-weight: bold;
  }
  .headerBorder {
    border: 1px solid #d9d9d9;
    height: 450px;
  }
  .fontback {
    background-color: #f6f7fb;
    height: 40px;
    line-height: 40px;
    padding-left: 20px;
  }
  .fontback2 {
    padding-top: 20px;
    padding-left: 20px;
  }
  .el-button--TheCustom {
    color: #666;
    border-color: #D9D9D9;
    background-color: #fff;
  }
  .el-button--TheCustom:hover  {
    color: #666;
    border-color: #ded2b8;
    background-color: #faf9f5;
  }
</style>
<style lang="scss">
#productInformation {
  .el-tree-node {
    white-space: nowrap;
    outline: 0;
    height: 32px;
  }
  .el-table__empty-text{
    padding-top: 100px;
    background: url("../../assets/img/other/nodata.svg") no-repeat;
    background-position: center 66px;
  }
  .el-table th {
    background-color: #f3f7ff !important;
  }
  .el-table thead {
    color: #333333;
    font-weight: 500;
  }
  .el-dialog__title {
    font-size: 14px;
  }
  #dialog {
    .el-dialog__header {
      padding: 20px 20px 10px;
      border-bottom: 1px solid #d9d9d9;
    }
    .el-button--primary {
      color: #FFF;
      background-color: #bda571;
      border-color: #bda571;
    }
    .el-button--primary:hover {
      color: #FFF;
      background-color: #c0ae8a;
      border-color: #c0ae8a;
    }
  }
  .w-e-menu{
    z-index: 2 !important;
  }
  #setHeader {
    .el-checkbox__label {
      padding-left: 16px !important;
    }
    .el-dialog__header {
      padding: 20px 20px 10px;
      border-bottom: 1px solid #f6f7fb;
    }
    .el-button--primary {
      color: #FFF;
      background-color: #bda571;
      border-color: #bda571;
    }
    .el-button--primary:hover {
      color: #FFF;
      background-color: #c0ae8a;
      border-color: #c0ae8a;
    }
  }
  .el-button+.el-button {
    margin-left: 1px;
  }
}
</style>
